export const translations = {
  en: {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      export: 'Export Excel',
      loading: 'Loading...',
      noData: 'No data available',
      confirm: 'Confirm',
      close: 'Close',
      submit: 'Submit',
      back: 'Back'
    },
    auth: {
      login: 'Login',
      logout: 'Logout',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      loginId: 'Email or Phone',
      forgotPassword: 'Forgot Password?',
      setupPassword: 'Set Up Password',
      subtitle: 'Pharmacy Consignment Management'
    },
    nav: {
      actionCenter: 'Action Center',
      stock: 'Stock & Expiry',
      settlement: 'Settlement Center',
      finance: 'Finance',
      createDO: 'Create DO',
      products: 'Products & Packages',
      pharmacyMap: 'Pharmacy Map',
      users: 'Users & Permissions',
      partners: 'Partners',
      settings: 'Settings',
      performance: 'Performance & Rankings',
      adjustments: 'Adjustments',
      partnerDOs: 'Partner Direct DOs',
      reportSale: 'Report Sale',
      myStock: 'My Stock',
      invoices: 'Invoices & Payment',
      restock: 'Restock',
      returns: 'Customer Returns',
      incomingDOs: 'Incoming DOs',
      liveSales: 'Live Sales',
      statements: 'My Statements',
      whereStock: 'Where My Stock Is'
    },
    dashboard: {
      thisMontSales: "This Month's Sales",
      receivables: 'Receivables Outstanding',
      payables: 'Payable to Partners',
      expiring: 'Units Expiring (6 months)',
      salesGrowth: 'Sales Growth',
      daily: 'Daily',
      monthly: 'Monthly',
      yearly: 'Yearly'
    }
  },
  zh: {
    common: {
      save: '保存',
      cancel: '取消',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      search: '搜索',
      filter: '筛选',
      export: '导出 Excel',
      loading: '加载中...',
      noData: '暂无数据',
      confirm: '确认',
      close: '关闭',
      submit: '提交',
      back: '返回'
    },
    auth: {
      login: '登录',
      logout: '登出',
      email: '电子邮件',
      phone: '电话',
      password: '密码',
      loginId: '电子邮件或电话',
      forgotPassword: '忘记密码？',
      setupPassword: '设置密码',
      subtitle: '药房寄售管理系统'
    },
    nav: {
      actionCenter: '行动中心',
      stock: '库存和过期',
      settlement: '结算中心',
      finance: '财务',
      createDO: '创建送货单',
      products: '产品和套餐',
      pharmacyMap: '药房地图',
      users: '用户和权限',
      partners: '合作伙伴',
      settings: '设置',
      performance: '业绩与排名',
      adjustments: '库存调整',
      partnerDOs: '合作伙伴直送单',
      reportSale: '报告销售',
      myStock: '我的库存',
      invoices: '发票和付款',
      restock: '补货',
      returns: '客户退货',
      incomingDOs: '待收送货单',
      liveSales: '实时销售',
      statements: '我的对账单',
      whereStock: '我的库存位置'
    },
    dashboard: {
      thisMontSales: '本月销售额',
      receivables: '应收账款',
      payables: '应付合作伙伴',
      expiring: '即将过期单位（6个月）',
      salesGrowth: '销售增长',
      daily: '每日',
      monthly: '每月',
      yearly: '每年'
    }
  }
};
